import { Font } from "@react-pdf/renderer";
import euclidBold from "src/fonts/EuclidCircularB-Bold.woff";
import euclidLight from "src/fonts/EuclidCircularB-Light.woff";
import euclidMedium from "src/fonts/EuclidCircularB-Medium.woff";
import euclidRegular from "src/fonts/EuclidCircularB-Regular.woff";
import euclidSemiBold from "src/fonts/EuclidCircularB-SemiBold.woff";

/*
 * Fonts are bundled through Vite (fingerprinted into dist/assets) instead of fetched from
 * /fonts/ at runtime: a missing public/fonts dir on the server used to make the SPA fallback
 * return index.html, which fontkit rejects with "Unknown font format". WOFF (not WOFF2) — it's
 * the format react-pdf documents as supported.
 */
Font.register({
	family: "Euclid",
	fonts: [
		{ src: euclidLight, fontWeight: 300, fontStyle: "normal" },
		{ src: euclidRegular, fontWeight: 400, fontStyle: "normal" },
		{ src: euclidMedium, fontWeight: 500, fontStyle: "normal" },
		{ src: euclidSemiBold, fontWeight: 600, fontStyle: "normal" },
		{ src: euclidBold, fontWeight: 700, fontStyle: "normal" },
	],
});
